import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import Navigation from '@App/navigation'
import ContentHeader from '@Components/ContentHeader'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router'
import { StoresContext } from '@App/contexts'

const CatalogTransferListHeader = () => {
    const { rightsholderStore } = useContext(StoresContext)
    const navigate = useNavigate()

    return (
        <ContentHeader
            title="Catalog Transfer Tool"
            descriptionElement={
                <>
                    <p>
                        If you are acquiring the right to collect royalties for a group of musical works that is
                        currently a part of another Member's catalog, you can use this Catalog Transfer Tool to submit a
                        request to transfer that other Member's shares of those works from their catalog to yours. Once
                        your request is approved, we will update our database to reflect your rights in the transferred
                        works, so you can begin receiving royalties for your share of those transferred works.
                    </p>
                    <p>
                        You can use the Catalog Transfer Tool to submit a request to transfer rights to all of the works
                        in another Member's catalog (a Full Catalog transfer request) or only rights to specific works
                        in that Member's Catalog (a Partial Catalog transfer request).
                    </p>
                </>
            }
        >
            <Button
                mainColor
                type="primary"
                icon={ICONS.add}
                onClick={() =>
                    navigate(
                        Navigation.rightholder.catalogTransfer.wizardLanding(rightsholderStore.currentRightsholderId)
                    )
                }
            >
                Start New Transfer
            </Button>
        </ContentHeader>
    )
}

export default CatalogTransferListHeader
